import { TableCell as MuiTableCell, tableCellClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: theme.spacing(1.8),
    letterSpacing: 0.2
  },
  [`&.${tableCellClasses.root}`]: {
    borderBottom: '1px solid rgba(43,45,66,0.1)'
  }
}));

export default TableCell;
